module.exports = __webpack_public_path__ + "img/client_coq_frit.af73b672.webp";